<template>
  <div>
    <v-expansion-panels accordion v-model="showPanel" class="base-shadow">
      <v-expansion-panel expand>
        <v-expansion-panel-header>
          <content-line icon="custom/text" text="Manage Questions" />
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div class="pa-4">
            <v-select
              label="Questionnaire"
              class="background-dark mb-4"
              v-model="context.state.questionnaire"
              :items="actionData.questionnaire"
              readonly
            />

            <v-checkbox
              v-if="!mediaControlsDisabled"
              v-model="context.state.showMedia"
              label="Show media after questionnaire"
              @change="updateQuestionnaire"
              class="mb-4"
            />

            <field-block
              title="Questionnaire Media"
              v-if="context.state.showMedia"
            >
              <v-select
                v-for="media in mediaList"
                :key="media.key"
                :label="media.title"
                class="background-dark mb-2"
                :value="context.state[media.key]"
                :items="actionData[media.key]"
                :readonly="mediaControlsDisabled"
              />
            </field-block>

            <div class="mt-4">
              <v-btn
                :class="showQuestionnaire ? '' : 'primary'"
                @click.prevent="toggleQuestionnaire"
              >
                {{ showQuestionnaire ? 'Hide' : 'Show' }}
              </v-btn>
              <v-btn
                class="ml-3"
                text
                color="primary"
                @click.prevent="$emit('close')"
              >
                Close
              </v-btn>
            </div>
          </div>

          <questionnaire-answers-table />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import QuestionnaireAnswersTable from './QuestionnaireAnswersTable';

export default {
  name: 'ActionPreScreenControls',
  components: {
    QuestionnaireAnswersTable,
  },
  props: {
    context: {
      type: Object,
      default: () => ({}),
    },
    actionData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showPanel: 0,
    };
  },
  computed: {
    showQuestionnaire() {
      return this.context.state.show;
    },
    mediaList() {
      return this.getMediaList();
    },
    mediaControlsDisabled() {
      return !this.actionData.canControlMedia;
    },
  },
  methods: {
    toggleQuestionnaire() {
      this.context.state.show = !this.showQuestionnaire;
      this.updateQuestionnaire();
    },

    updateQuestionnaire() {
      this.$emit('update');
    },

    assignData() {
      for (let key in this.actionData) {
        const param = this.actionData[key];
        this.context.state[key] = Array.isArray(param) ? param[0] : param;
      }
    },

    getMediaList() {
      const mediaList = [
        {
          title: 'Intro Video',
          key: 'introVideo',
        },
        {
          title: 'Outro Video',
          key: 'outroVideo',
        },
        {
          title: 'Playlist',
          key: 'outroAudio',
        },
      ];

      return mediaList.filter(({ key }) => {
        return !!this.actionData[key];
      });
    },
  },
  mounted() {
    this.assignData();
  },
};
</script>
